import { render } from "./AsideOld.vue?vue&type=template&id=5da476a5&scoped=true&ts=true"
import script from "./AsideOld.vue?vue&type=script&lang=ts"
export * from "./AsideOld.vue?vue&type=script&lang=ts"

import "./AsideOld.vue?vue&type=style&index=0&id=5da476a5&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da476a5"]])

export default __exports__